<template>
  <div>
    <logged-in-header />
    <settlements />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import settlements from "../components/settlements/Settlements";

export default {
  components: {
    loggedInHeader,
    settlements
  }
};
</script>
